module.exports = new __parcel__URL__("Charlie_Text-Black_Italic.30e41609.woff").toString();